import { provideEffects } from '@ngrx/effects';
import { CategoryApplicationsEffects } from './category-applications.effects';

export const provideCategoryApplicationsStore = () => [provideEffects([CategoryApplicationsEffects])];
